import styled from 'styled-components';
import { X } from '@phosphor-icons/react';
import { CommonUtility } from '../../../utility';

export const fieldTypes = {
  service: 'service',
  packages: 'packages',
  invoiceId: 'invoiceId',
  customers: 'customers',
};

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  max-height: 40vh;
  overflow-y: auto;
  margin-bottom: 10px;
`;

export const DynamicFieldContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.box};
  border-radius: 5px;
  padding: 7px;
  column-gap: 5px;
  .icon-btn {
    display: none;
  }
  &:hover {
    .icon-btn {
      display: block;
    }
  }
`;

const GreyBox = styled.div`
  background-color: ${({ theme }) => theme.colors.box};
  padding: 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grey};
`;

export function NoDataBox() {
  return <GreyBox>No Configuration(s)</GreyBox>;
}

const configChanged = (
  formValues,
  packageMaterialMappings,
  customerMappings,
  serviceFields,
  quickBookConfig,
) => {
  const serviceSame =
    JSON.stringify(serviceFields) === JSON.stringify(quickBookConfig?.serviceMappings);

  const packagingSame =
    JSON.stringify(customerMappings) ===
    JSON.stringify(quickBookConfig?.customerMappings);

  const customerSame =
    JSON.stringify(packageMaterialMappings) ===
    JSON.stringify(quickBookConfig?.packageMaterialMappings);

  const prefixEqual = quickBookConfig?.invoiceIdPrefix === formValues.prefix;

  return !serviceSame || !prefixEqual || !customerSame || !packagingSame;
};

const parseCustomerData = customerFormValue => {
  const customerMappings = {};
  Object.keys(customerFormValue).forEach(customerId => {
    customerMappings[customerId] = customerFormValue[customerId]?.value;
  });

  return CommonUtility.removeEmptyFields(customerMappings);
};

const parsePackagingMaterialData = packagingMaterialFormValue => {
  const packageMaterialMappings = {};
  Object.keys(packagingMaterialFormValue).forEach(packagingId => {
    packageMaterialMappings[packagingId] = {
      ACCOUNT: packagingMaterialFormValue[packagingId].ACCOUNT,
      ITEM: packagingMaterialFormValue[packagingId].ITEM,
    };
  });

  return CommonUtility.removeEmptyFields(packageMaterialMappings);
};

export const readyPayload = (
  serviceFields,
  quickBookConfig,
  formValues,
  packagingMaterialFormValue,
  customerFormValue,
) => {
  const payload = {
    invoiceIdPrefix: formValues.prefix,
    serviceMappings: CommonUtility.removeEmptyFields(
      JSON.parse(JSON.stringify(serviceFields)),
    ),
    packageMaterialMappings: parsePackagingMaterialData(packagingMaterialFormValue),
    customerMappings: parseCustomerData(customerFormValue),
  };

  if (
    configChanged(
      formValues,
      payload.packageMaterialMappings,
      payload.customerMappings,
      serviceFields,
      quickBookConfig,
    )
  ) {
    return payload;
  }
  return null;
};

const Pill = styled.div`
  background-color: ${({ theme }) => theme.colors.box};
  padding: 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  column-gap: 5px;
  font-size: 12px;

  .icon {
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
`;

const PillContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 5px;
  column-gap: 5px;
  margin-top: 5px;
`;

export function CustomerPills({ customers, onRemoveCustomer }) {
  if (!CommonUtility.isValidArray(customers)) {
    return (
      <PillContainer>
        <Pill>
          <span>All Customers Selected</span>
        </Pill>
      </PillContainer>
    );
  }

  return (
    <PillContainer>
      {customers?.map(customer => (
        <Pill>
          <span>{customer?.organizationName}</span>
          <X
            onClick={() => onRemoveCustomer(customer)}
            className="cursor-pointer icon"
            size={14}
          />
        </Pill>
      ))}
    </PillContainer>
  );
}
